// extracted by mini-css-extract-plugin
module.exports = {"bookLogHistory":"BookLogHistory_bookLogHistory__3tQvj","bookLogHistoryTitle":"BookLogHistory_bookLogHistoryTitle__2z9fb"};